<template>
  <div>
    <DealCandidateSummary
      :firstName="firstName"
      :lastName="lastName"
      :emailAddress="emailAddress"
    />
    <ExpensesSummary
      v-if="showExpensesSection"
      :expenses="expenses"
    />
    <SummaryTitle title="Permanent Placement"/>
    <SummaryItem item-title="Job Title" v-if="!!jobTitle">
      <template v-slot:content>
        {{ jobTitle ? jobTitle : 'Missing' }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Placement Date">
      <template v-slot:content>
        {{ permPlacementDateLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Invoice Date">
      <template v-slot:content>
        {{ permPlacementInvoiceDateLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Invoice Due Date">
      <template v-slot:content>
        {{ permPlacementInvoiceDueDateLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Salary">
      <template v-slot:content>
        {{ permPlacementSalaryLabel }}
      </template>
    </SummaryItem>
    <SummaryItem item-title="Net Fee">
      <template v-slot:content>
        {{ netFeeLabel }}
      </template>
    </SummaryItem>
    <CommissionsSummary
      v-if="showCommissionsSection"
      :commissions="commissions"
    >
    </CommissionsSummary>
  </div>
</template>
<script>
import formatCurrency from '@/lib/display/formatCurrency'
import formatDate from '@/lib/display/formatDate'
import { SummaryTitle, SummaryItem, ExpensesSummary, CommissionsSummary } from '@/components/shared/display'
import { PERCENTAGE } from '@/lib/constants/permPlacementFeeTypes'
import DealCandidateSummary from './DealCandidateSummary.vue'

export default {
  components: {
    SummaryItem,
    SummaryTitle,
    ExpensesSummary,
    CommissionsSummary,
    DealCandidateSummary
  },
  props: [
    'firstName',
    'lastName',
    'emailAddress',
    'jobTitle',
    'permPlacementDate',
    'permPlacementInvoiceDate',
    'permPlacementInvoiceDueDate',
    'permPlacementSalary',
    'permPlacementFee',
    'permPlacementFeeTypeId',
    'expenses',
    'commissions'
  ],
  computed: {
    permPlacementDateLabel () {
      return this.permPlacementDate ? formatDate(this.permPlacementDate) : 'Missing'
    },
    permPlacementInvoiceDateLabel () {
      return this.permPlacementInvoiceDate ? formatDate(this.permPlacementInvoiceDate) : 'Missing'
    },
    permPlacementInvoiceDueDateLabel () {
      return this.permPlacementInvoiceDueDate ? formatDate(this.permPlacementInvoiceDueDate) : 'Missing'
    },
    permPlacementSalaryLabel () {
      return this.permPlacementSalary ? formatCurrency(this.permPlacementSalary) : 'Missing'
    },
    netFeeLabel () {
      return this.permPlacementSalary && this.permPlacementFee && this.permPlacementFeeTypeId
        ? (this.permPlacementFeeTypeId === PERCENTAGE
          ? formatCurrency((this.permPlacementSalary * this.permPlacementFee) / 100) : formatCurrency(this.permPlacementFee))
        : 'Missing'
    },
    showCommissionsSection () {
      return this.commissions && this.commissions.length > 0
    },
    showExpensesSection () {
      return this.expenses && this.expenses.length > 0
    }
  }
}
</script>
